import React, { useEffect, useState } from 'react'
import { Coordinates } from '../../../../../types/address'
import { fetchDecodedAddress, fetchPlaces } from '../../../../../services/api/address';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import SearchSection from '../../../../address/SearchSection';

const indiaCenter: Coordinates = {
    latitude: 22.9734,
    longitude: 78.6569,
};

const NearbyStores: React.FC<{ query: string, type?: string, onChange?: (placeId: string | null) => void }> = ({ query, onChange }) => {

    const [coordinates, setCoordinates] = useState<Coordinates | null>(null);
    const [loading, setLoading] = useState(false);
    const [resolvingLocation, setResolvingLocation] = useState(false);
    const [stores, setStores] = useState<any[]>([]);
    const [selectedPlaceId, setSelectedPlaceId] = useState<string | null>(null);
    const [selectedLocationLabel, setSelectedLocationLabel] = useState<string | null>(null);

    const hubId = useSelector((state: RootState) => state.auth.selectedHubId);

    const handleCreatorLocationSelection = async (place: any) => {
        const placeId = place?.placePrediction?.placeId;
        if (!hubId || !placeId) return;

        const mainText = place?.placePrediction?.structuredFormat?.mainText?.text;
        const secondaryText = place?.placePrediction?.structuredFormat?.secondaryText?.text;
        setSelectedLocationLabel(
            [mainText, secondaryText].filter(Boolean).join(', ') || 'Selected location'
        );

        try {
            setResolvingLocation(true);
            const result = await fetchDecodedAddress(hubId, placeId);
            if (result?.lat != null && result?.lng != null) {
                setCoordinates({ latitude: result.lat, longitude: result.lng });
            }
        } catch (error) {
            console.error(error);
            setSelectedLocationLabel(null);
        } finally {
            setResolvingLocation(false);
        }
    };

    const resetCreatorLocation = () => {
        setCoordinates(null);
        setStores([]);
        setSelectedPlaceId(null);
        setSelectedLocationLabel(null);
        onChange?.(null);
    };

    const fetchStores = async () => {
        if (!coordinates || !query || !hubId) return
        try {
            setLoading(true);
            const places = await fetchPlaces(hubId, query, coordinates);
            if (Array.isArray(places)) {
                setStores(places);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (coordinates) fetchStores();
    }, [coordinates])

    useEffect(() => {
        onChange?.(selectedPlaceId);
    }, [selectedPlaceId])

    return (
        <div className='nearby-stores'>
            {
                resolvingLocation ? (
                    <div className='d-flex justify-content-center align-items-center h-100 flex-column gap-2'>
                        <div className="spinner-border text-primary"></div>
                        <span>Loading location...</span>
                    </div>
                ) : coordinates ? (
                    <div className='h-100'>
                        {selectedLocationLabel && (
                            <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
                                <span className="fs-12 text-muted text-truncate">{selectedLocationLabel}</span>
                                <button
                                    type="button"
                                    onClick={resetCreatorLocation}
                                    className="change-location-btn flex-shrink-0"
                                >
                                    Change
                                </button>
                            </div>
                        )}
                        {
                            loading ? (
                                <div className='d-flex justify-content-center align-items-center h-100 flex-column gap-2'>
                                    <div className="spinner-border text-primary"></div>
                                    <span>Loading...</span>
                                </div>
                            ) : (
                                <div className='h-100'>
                                    {
                                        (stores.length > 0) ? (
                                            <div className="location-list mt-0">
                                                {
                                                    stores.map((store, i) => {
                                                        return (
                                                            <div className="location-list-item cursor-pointer" key={i} onClick={() => setSelectedPlaceId(store.placePrediction?.placeId ?? null)} >
                                                                <div className="location-list-item-top">
                                                                    <div className="gig-selection-checkbox-wrapper">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input gig-selection-check-input radio-check"
                                                                            checked={store.placePrediction?.placeId === selectedPlaceId}
                                                                            onChange={() => setSelectedPlaceId(store.placePrediction?.placeId ?? null)}
                                                                        />
                                                                    </div>
                                                                    {/* <LocationArrowIcon /> */}
                                                                    <span className="location-list-item-title">
                                                                        {store.placePrediction?.structuredFormat?.mainText?.text}
                                                                    </span>
                                                                </div>
                                                                <span className="location-list-item-address">
                                                                    {store.placePrediction?.structuredFormat?.secondaryText?.text}
                                                                </span>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        ) : (
                                            <div className="d-flex justify-content-center align-items-center h-100 flex-column gap-2">
                                                <span>We couldn't find a store near this location!</span>
                                            </div>
                                        )
                                    }
                                </div>
                            )
                        }
                    </div>
                ) : (
                    <div className='h-100'>
                        <span className="fs-12 text-muted d-block mb-3">
                            Search for the creator&apos;s location to find nearby stores
                        </span>
                        <SearchSection
                            currentGeolocation={indiaCenter}
                            onCancel={() => {}}
                            onPlaceSelection={handleCreatorLocationSelection}
                        />
                    </div>
                )
            }
        </div>
    )
}

export default NearbyStores